import { render } from "./InsertSezPage.vue?vue&type=template&id=61a8b2e6&scoped=true&ts=true"
import script from "./InsertSezPage.vue?vue&type=script&lang=ts"
export * from "./InsertSezPage.vue?vue&type=script&lang=ts"

import "./InsertSezPage.vue?vue&type=style&index=0&id=61a8b2e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a8b2e6"]])

export default __exports__